"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactColor = require("react-color");

var _Picker = _interopRequireDefault(require("./Picker"));

require("./styles.css");

var _Input = _interopRequireDefault(require("../Input"));

var _lib = require("../../lib");

var _common = require("../../common");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var colorType = ['hex', 'rgb', 'hsl'];

var ColorPicker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ColorPicker, _PureComponent);

  function ColorPicker(props) {
    var _this;

    _classCallCheck(this, ColorPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColorPicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getDefaultValue", function () {
      var type = _this.props.type;

      switch (type) {
        case 'rgb':
          return {
            r: 0,
            g: 0,
            b: 0,
            a: 1
          };

        case 'hsl':
          return {
            h: 0,
            s: 0,
            l: 0,
            a: 1
          };

        default:
          return '#000000';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getOutputValue", function () {
      var type = _this.props.type;
      var value = _this.state.value;

      if (type === 'rgb' || type === 'hsl') {
        if ((0, _lib.objHasKeys)(value)) {
          var keys = Object.keys(value);
          var output = keys.map(function (k, index, arr) {
            var upperKey = k.toUpperCase();
            var roundedValue = type === 'hsl' ? Math.round(value[k] * 100) : value[k];
            return index === arr.length - 1 ? "".concat(upperKey, " : ").concat(roundedValue) : "".concat(upperKey, " : ").concat(roundedValue, " , ");
          });
          return output.join(' ');
        }
      }

      if (value) return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getPreviewStyle", function () {
      var type = _this.props.type;
      var value = _this.state.value;
      var style = {};

      if (type === 'hex') {
        style = {
          background: "".concat(value),
          border: "1px solid ".concat(value)
        };
      }

      if (type === 'rgb') {
        style = {
          background: "rgba(".concat(value.r, ", ").concat(value.g, ", ").concat(value.b, ", ").concat(value.a, ")"),
          border: "1px solid rgba(".concat(value.r, ", ").concat(value.g, ", ").concat(value.b, ", 1)")
        };
      }

      if (type === 'hsl') {
        style = {
          background: "hsla(".concat(value.h, ", ").concat(value.s * 100, "%, ").concat(value.l * 100, "%, ").concat(value.a, ")"),
          border: "1px solid hsla(".concat(value.h, ", ").concat(value.s * 100, "%, ").concat(value.l * 100, "%, 1)")
        };
      }

      return style;
    });

    _defineProperty(_assertThisInitialized(_this), "preventTouchMove", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpenPicker", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      _this.setState({
        visible: true
      }, function () {
        document.addEventListener('touchmove', _this.preventTouchMove, {
          passive: false
        });
        var _this$props = _this.props,
            name = _this$props.name,
            onOpen = _this$props.onOpen;

        if (onOpen) {
          onOpen(e, {
            name: name,
            value: _this.state.value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClosePicker", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      _this.setState({
        visible: false
      }, function () {
        document.removeEventListener('touchmove', _this.preventTouchMove, {
          passive: false
        });
        var _this$props2 = _this.props,
            name = _this$props2.name,
            onClose = _this$props2.onClose;

        if (onClose) {
          onClose(e, {
            name: name,
            value: _this.state.value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (color, e) {
      var type = _this.props.type;

      if (color[type]) {
        _this.setState({
          value: color[type]
        }, function () {
          var _this$props3 = _this.props,
              name = _this$props3.name,
              onChange = _this$props3.onChange;

          if (onChange) {
            onChange(e, {
              name: name,
              value: _this.state.value
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [ColorPicker.className];
      var propNames = ['extendable'];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      return names.join(' ');
    });

    var _value = props.value;

    var defaultValue = _this.getDefaultValue();

    _this.state = {
      prevProps: {
        value: _value
      },
      value: _value || defaultValue,
      visible: false
    };
    return _this;
  }

  _createClass(ColorPicker, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('touchmove', this.preventTouchMove, {
        passive: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          as = _this$props4.as,
          type = _this$props4.type,
          onChange = _this$props4.onChange,
          onOpen = _this$props4.onOpen,
          onClose = _this$props4.onClose,
          name = _this$props4.name,
          extendable = _this$props4.extendable,
          disabled = _this$props4.disabled,
          rest = _objectWithoutProperties(_this$props4, ["as", "type", "onChange", "onOpen", "onClose", "name", "extendable", "disabled"]);

      var _this$state = this.state,
          visible = _this$state.visible,
          value = _this$state.value;
      var classNames = this.classNames();
      var previewStyle = this.getPreviewStyle();
      var Wrapper = (0, _lib.getElementType)(this, this.props);
      return _react["default"].createElement(Wrapper, {
        className: classNames
      }, _react["default"].createElement("div", {
        className: "input-wrapper"
      }, _react["default"].createElement(_Input["default"], _extends({}, rest, {
        readOnly: true,
        disabled: disabled,
        value: this.getOutputValue(),
        onFocus: this.handleOpenPicker
      })), _react["default"].createElement("div", {
        className: "preview",
        onClick: disabled ? null : this.handleOpenPicker,
        style: previewStyle
      })), visible ? _react["default"].createElement("div", {
        className: "dropdown-wrapper"
      }, _react["default"].createElement("div", {
        className: "MHub-ColorPicker-Overlay",
        onClick: this.handleClosePicker
      }), _react["default"].createElement(_reactColor.ChromePicker, {
        color: value,
        onChange: this.handleOnChange
      })) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var visible = props.visible,
          value = props.value;
      return {
        // Store the previous props in state
        prevProps: {
          visible: visible,
          value: value
        },
        visible: prevProps.visible !== visible ? visible : state.visible,
        value: prevProps.value !== value ? value : state.value
      };
    }
  }]);

  return ColorPicker;
}(_react.PureComponent);

exports["default"] = ColorPicker;

_defineProperty(ColorPicker, "Picker", _Picker["default"]);

_defineProperty(ColorPicker, "className", 'MHub-ColorPicker');

_defineProperty(ColorPicker, "propTypes", {
  as: _common.customPropTypes.as,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  extendable: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(colorType)
});

_defineProperty(ColorPicker, "defaultProps", {
  as: 'div',
  name: null,
  onChange: null,
  onOpen: null,
  onClose: null,
  value: null,
  extendable: false,
  disabled: false,
  type: 'hex'
});